import { IDashboardBenchmarkSalesResponse } from './dashboard-benchmark-sales.interface'
import { IDashboardGoalsResponse } from './dashboard-goals.inteface'
import { IDashboardGrossProfitResponse } from './dashboard-gross-profit.inteface'
import { IDashboardLaborResponse } from './dashboard-labor.inteface'
import { IDashboardRankingResponse } from './dashboard-ranking.inteface'

export interface IDashboardAllResponse {
  goals: IDashboardGoalsResponse
  grossProfit: IDashboardGrossProfitResponse
  sales: IDashboardBenchmarkSalesResponse
  labor: IDashboardLaborResponse
  leaderboard: IDashboardRankingResponse
}
